import { CHCMedicarePlanFinder } from './medicare-plan-finder.component.js';
export { CHCMedicarePlanFinder };

customElements.define('chcapp-medicare-plan-finder', CHCMedicarePlanFinder);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-medicare-plan-finder': CHCMedicarePlanFinder;
  }
}
